import queryString from "query-string";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import ExchangeHistoryFilter from "./ExchangeHistoryFilter";
import FilterAppliedList from "../../../elements/filter/FilterAppliedList";
import ExchangeHistoryList from "./ExchangeHistoryList";
import Notification from "../../../elements/notification/Notification";
import ItemsPerPageSelect from "../../../elements/filter/ItemsPerPageSelect";

import { itemsPerPageValue } from "../../../../utils/ItemsPerPageValue";
import { checkFilterItem, fetchFilterData } from "../../../../utils/fetchFilterData";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import { parseAxiosError } from "../../../../utils/response";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../../utils/consts";

import MaterialPagination from "../../../styles/materialPagination";
import { StyledExchangeHistoryWrapper } from "../../styledExchange";

const ExchangeHistoryContainer = () => {
  const history = useHistory();

  let searchParams = queryString.parse(history.location.search);
  const { t } = useTranslation("exchangerPage");

  const [exchangeHistory, setExchangeHistory] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);
  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "currentTab": checkFilterItem(history, "currentTab", "exchange-history"),
    "id": checkFilterItem(history, "id", null),
    "pair.user.email": checkFilterItem(history, "pair.user.email", null),
    "pair.user.nickname": checkFilterItem(history, "pair.user.nickname", null),
    "pair.exchangePair.inService.name": checkFilterItem(history, "pair.exchangePair.inService.name", null),
    "pair.exchangePair.outService.name": checkFilterItem(history, "pair.exchangePair.outService.name", null),
    "pair.exchangePair.inCurrency.asset": checkFilterItem(history, "pair.exchangePair.inCurrency.asset", null),
    "pair.exchangePair.outCurrency.asset": checkFilterItem(history, "pair.exchangePair.outCurrency.asset", null),
    "inAmount[gte]": checkFilterItem(history, "inAmount[gte]", null, true, true),
    "inAmount[lte]": checkFilterItem(history, "inAmount[lte]", null, true),
    "outAmount[gte]": checkFilterItem(history, "outAmount[gte]", null, true),
    "outAmount[lte]": checkFilterItem(history, "outAmount[lte]", null, true),
    "createdAt[gte]": checkFilterItem(history, "createdAt[gte]", null, true),
    "createdAt[lte]": checkFilterItem(history, "createdAt[lte]", null, true),
    "status.value": checkFilterItem(history, "status.value", null)
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchExchanges = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/exchanges" + filterUrl, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setExchangeHistory(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  useEffect(() => {
    fetchExchanges();
  }, [filterData]);

  //TODO add pusher

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <Helmet>
        <title>{t("history.meta.title")}</title>
      </Helmet>
      <StyledExchangeHistoryWrapper>
        <div className="exchange-history-head">
          <ExchangeHistoryFilter
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <ItemsPerPageSelect
            itemsPerPage={filterData.itemsPerPage}
            setItemsPerPage={(data) => setFilterData({
              ...filterData,
              "itemsPerPage": data,
              page: 1
            })}
          />
        </div>
        <FilterAppliedList
          filterData={filterData}
          setFilterData={setFilterData}
        />
        <ExchangeHistoryList
          exchangeHistory={exchangeHistory}
          notification={notification}
          setNotification={setNotification}
        />
        {totalPageCount > 1  &&
          <MaterialPagination
            count={totalPageCount}
            shape="rounded"
            page={filterData.page}
            onChange={(event, page) => onChangePage(event, page)}
          />}
      </StyledExchangeHistoryWrapper>
    </>
  );
};

export default ExchangeHistoryContainer;